// extracted by mini-css-extract-plugin
export default {"root":"VtDbEi","search":"FXUYgl","input":"V3IOrO","expanded":"cHTO1r"};